var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noticeModalContainer"},[_c('b-modal',{ref:"noticeDeleteModal",attrs:{"centered":"","headerBgVariant":"primary","id":"noticeDeleteModal","size":"lg","title":"Confirmar eliminar aviso","o-close-on-backdrop":"true","cancel-title":"Cancelar","ok-title":"Eliminar"},on:{"ok":_vm.deleteNotice}},[_vm._v("\n    ¿Confirma que desea eliminar este aviso?\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645029a0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notices/NoticeDeleteModal.vue
// module id = 1118
// module chunks = 1